//=require main.js
//=require components/select2.min.js

$(document).ready(function () {
    $(document).delegate('.show-site-plan', 'click', function () {
        $('.overlay').fadeIn();
        let sitePlanUrl = $(this).data('site-plan');
        $('#sitePlane').attr("src",sitePlanUrl);
    })

    $("#site_plan .close").click(function () {
        $('.overlay').fadeOut();
        $('#sitePlane').attr("src", '');
    })

    $(document).on('keypress',function(event) {
        if (event.key === "Enter") {
            let keyWord = $('#input-search-project').val();
            let district = $(".district option:selected").val();
            let province = $(".province option:selected").val();
            if (province === "all") {
                $('.district').prop("disabled", true);
                $('.district').html('<option value="all">Quận/Huyện</option>');

            } else {
                $.ajax({
                    url: '/filter-du-an',
                    method: "GET",
                    data: {province: province, keyWord: keyWord, district: district},
                    beforeSend: function () {
                        $('.district').prop("disabled", true);
                        $('.overlay').fadeIn();
                    },
                    success: function (data) {
                        $('.loading-block').html('<img src="/images/icons/spin.gif" id="loading" data-id=' + JSON.stringify(data.projectId) + ' data-count="' + data.projectsCount + '" style="cursor: pointer">');
                        $('.district').prop("disabled", false);
                        $('.district').html(data.districts);
                        let html = eachAction(data);
                        $('.list-partner').html(html);
                        $('.overlay').fadeOut();
                    }
                });
            }
        }
    });

    $('.button-search').click(function () {
        let keyWord = $('#input-search-project').val();
        let district = $(".district option:selected").val();
        let province = $(".province option:selected").val();
        if (province === "all") {
            $('.district').prop("disabled", true);
            $('.district').html('<option value="all">Quận/Huyện</option>');

        } else {
            $.ajax({
                url: '/filter-du-an',
                method: "GET",
                data: {province: province, keyWord: keyWord, district: district},
                beforeSend: function () {
                    $('.district').prop("disabled", true);
                    $('.overlay').fadeIn();
                },
                success: function (data) {
                    $('.loading-block').html('<img src="/images/icons/spin.gif" id="loading" data-id=' + JSON.stringify(data.projectId) + ' data-count="' + data.projectsCount + '" style="cursor: pointer">');
                    $('.district').prop("disabled", false);
                    $('.district').html(data.districts);
                    let html = eachAction(data);
                    $('.list-partner').html(html);
                    $('.overlay').fadeOut();
                }
            });
        }
    })

    $('.province').on('change', function () {
        let keyWord = $('#input-search-project').val();
        let province = $(this).val();
        let district = $(".district option:selected").val();
        if (province === "all") {
            $('.district').prop("disabled", true);
            $('.district').html('<option value="all">Quận/Huyện</option>');

        } else {
            $.ajax({
                url: '/filter-du-an',
                method: "GET",
                data: {province: province, keyWord: keyWord, district: district},
                beforeSend: function () {
                    $('.district').prop("disabled", true);
                    $('.overlay').fadeIn();
                },
                success: function (data) {
                    $('.loading-block').html('<img src="/images/icons/spin.gif" id="loading" data-id=' + JSON.stringify(data.projectId) + ' data-count="' + data.projectsCount + '" style="cursor: pointer">');
                    $('.district').prop("disabled", false);
                    $('.district').html(data.districts);
                    let html = eachAction(data);
                    $('.list-partner').html(html);
                    $('.overlay').fadeOut();
                }
            });
        }
    })

    $('.district').on('change', function () {
        let keyWord = $('#input-search-project').val();
        let district = $(this).val();
        let province = $(".province option:selected").val()
        $.ajax({
            url: '/filter-du-an',
            method: "GET",
            data: {district: district, keyWord: keyWord, province: province},
            beforeSend: function () {
                $('.overlay').fadeIn();
            },
            success: function (data) {
                $('.loading-block').html('<img src="/images/icons/spin.gif" id="loading" data-id=' + JSON.stringify(data.projectId) + ' data-count="' + data.projectsCount + '" style="cursor: pointer">');
                let html = eachAction(data);
                $('.list-partner').html(html);
                $('.overlay').fadeOut();
            },
            error: function (error) {
                console.log(error)
            }
        });
    })

    $(window).scroll(function () {
        if ($(window).scrollTop() === ($(document).height() - window.innerHeight)) {
            appendContent();
        }
    });

    $('.province').select2({
        placeholder: "Chọn Tỉnh/Thành phố",
        allowClear: true,
    });
    $('.district').select2({
        placeholder: "Chọn Quận/ Huyện",
        allowClear: true,
    });
});

var eachAction = function (data) {
    let html = '';
    if (data.projects !== undefined && data.projects.length > 0) {
        $.each(data.projects, function (index, value) {
            let myAddress = '';
            let thumbnail = '';
            let desc = '';

            if (value.address !== undefined) {
                myAddress += value.address + ', ';
            }

            myAddress += value?.ward?.name_with_type ? value.ward.name_with_type + ', ' : '';
            myAddress += value?.district?.name_with_type ? value.district.name_with_type + ', ' : '';
            myAddress += value?.province?.name_with_type ? value.province.name_with_type : '';

            if (value.siteplan_url === undefined || value.siteplan_url === "" || value.siteplan_url === null) {
                thumbnail += `<a href="/chi-tiet-du-an/${value.slug}"><div class="block-thumbnail position-relative">
                            <img src="${value?.featured_image?.url
                    ? value.featured_image.url : ""}" class="w-100">
                            <div class="img-overlay"></div>
                        </div></a>`;

                desc += `
                    <a href="/chi-tiet-du-an/${value.slug}">
                        <div class="block-information">
                            <div class="other d-flex">
                                <div class="other-right">
                                    <div class="name line-camp-2 text-uppercase mb-4 text-center">
                                        ${value.name}
                                    </div>
                                    <div class="d-flex" style="margin-top: -15px">
                                        <div style="width: 60%" class="d-flex">
                                            <div class="mr-1">
                                                <img src="/images/icons/icon-location.svg">
                                            </div>
                                            <div class="line-camp-3">
                                                ${myAddress}
                                            </div>
                                        </div>
                                        <div class="ml-2 d-flex" style="width: 40%">
                                            <div class="mr-1">
                                                <img src="/images/v2/doi-tac-trien-khai/icon-project.svg">
                                            </div>
                                            <div>
                                                ${value?.count_portfolio ? value.count_portfolio + ' Thiết kế mẫu' : 'Không có thiết kế mẫu nào'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                `;
            } else {
                thumbnail += `<div style="cursor: pointer" class="show-site-plan" data-toggle="modal" data-target="#site_plan" data-site-plan=${value.siteplan_url}><div class="block-thumbnail position-relative">
                            <img src="${value?.featured_image?.url
                    ? value.featured_image.url : ""}" class="w-100">
                            <div class="img-overlay"></div>
                        </div></div>`

                desc += `
                    <div style="cursor: pointer" class="show-site-plan" data-toggle="modal" data-target="#site_plan" data-site-plan=${value.siteplan_url}>
                        <div class="block-information">
                            <div class="other d-flex">
                                <div class="other-right">
                                    <div class="name line-camp-2 text-uppercase mb-4 text-center">
                                        ${value.name}
                                    </div>
                                    <div class="d-flex" style="margin-top: -15px">
                                        <div style="width: 60%" class="d-flex">
                                            <div class="mr-1">
                                                <img src="/images/icons/icon-location.svg">
                                            </div>
                                            <div class="line-camp-3">
                                                ${myAddress}
                                            </div>
                                        </div>
                                        <div class="ml-2 d-flex" style="width: 40%">
                                            <div class="mr-1">
                                                <img src="/images/v2/doi-tac-trien-khai/icon-project.svg">
                                            </div>
                                            <div>
                                                ${value?.count_portfolio ? value.count_portfolio + ' Thiết kế mẫu' : 'Không có thiết kế mẫu nào'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
            }

            html += `<div class="col-xl-3 col-md-6 col-12 item-partner">
                        ${thumbnail}
                        ${desc}
                    </div>`
        })
    } else {
        html += `<div class="col-xl-12 col-md-12 col-12 text-center">
                        Không tìm thấy kết quả nào phù hợp
                      </div>`
    }
    return html;
}

var appendContent = function () {
    let _totalCurrentResult = $(".item-partner").length;
    let keyWord = $('#input-search-project').val();
    let province = $(".province option:selected").val();
    let district = $(".district option:selected").val();
    let total = $('#loading').data('count');
    $.ajax({
        url: '/load-more-du-an',
        type: 'get',
        data: {keyWord: keyWord, province: province, district: district, _start: _totalCurrentResult},
        dataType: 'json',
        beforeSend: function () {
            _totalCurrentResult = $(".item-partner").length;
            if (_totalCurrentResult < total) {
                $('#loading').fadeIn();
            }
        },
        success: function (data) {
            _totalCurrentResult = $(".item-partner").length;
            if (_totalCurrentResult < total) {
                $('.loading-block').html('<img src="/images/icons/spin.gif" data-count=' + data.projectsCount + ' id="loading" style="cursor: pointer">');
                let html = eachAction(data);
                console.log('html', html)
                $('.list-partner').append(html);
                $('#loading').fadeOut();
            }
        }
    })
};
